export default "__VITE_ASSET__02139dc6__"